import { isFunction } from 'lodash';
import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  FETCH_NOTIFY,
} from '../actions/notify/action_types';

import actions from '../actions/notify';
import rf from '../../requests/RequestFactory';

// saga effect

function* fetchNotify(action) {
  try {
    const resp = yield call((params) => rf.getRequest('NotifyRequest').fetchNotify(params), action.params);
    yield put(actions.fetchNotifyActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback(resp.total_count);
    }
  } catch (err) {
    yield put(actions.fetchNotifyActionFailed(err));
  }
}

function* watchAllNotify() {
  yield takeLatest(FETCH_NOTIFY, fetchNotify);
}

export default function* rootSaga() {
  yield all([fork(watchAllNotify)]);
}
